import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/LayoutBuilder/LayoutBuilderRenderer.tsx
var LayoutBuilderRenderer = ({ layout: layoutSchema, renderComponentFromId, styles }) => {
	return /* @__PURE__ */ jsx("div", {
		className: "flex",
		children: /* @__PURE__ */ jsx("div", {
			className: "layout-builder-container grow",
			children: /* @__PURE__ */ jsx("div", {
				className: "lb-layout",
				children: useMemo(() => {
					return layoutSchema?.layout || [];
				}, [layoutSchema]).map((row) => /* @__PURE__ */ jsx("div", {
					className: "base lb-row",
					style: styles?.Row,
					children: /* @__PURE__ */ jsx("div", {
						className: "lb-columns",
						children: row.children?.map((column) => /* @__PURE__ */ jsx("div", {
							className: "lb-base lb-column",
							style: styles?.Column,
							children: column?.children?.map((component) => /* @__PURE__ */ jsx("div", {
								className: "lb-base lb-component",
								style: styles?.Component,
								children: renderComponentFromId(component.id)
							}, component.id))
						}, column.id))
					})
				}, row.id))
			})
		})
	});
};
//#endregion
export { LayoutBuilderRenderer };

//# sourceMappingURL=LayoutBuilderRenderer.js.map